const Url = require('url-parse');
const linkify = require('linkifyjs');
const getSha1 = require('crypto-js/sha1');

/* functions shared between client and server side */

const sha1 = string => {
  return getSha1(string).toString();
};

const translateNode = node => {

  const newNode = Object.assign({}, node);
  delete newNode._store;
  delete newNode._cache;
  newNode.uuid = node.id;
  newNode.display_properties = {};
  newNode.display_properties.x = node.x;
  newNode.display_properties.y = node.y;
  newNode.display_properties.height = node.height;
  newNode.display_properties.isCollapsed = node.isCollapsed;
  newNode.display_properties.absolutePosition = node.absolutePosition;
  newNode.display_properties.orderIndex = node.orderIndex;
  newNode.parent_node_uuid = node.parentId;
  newNode.canonical_node_uuid = node.canonicalNodeUUID;
  newNode.external_identifier = node.externalIdentifier;
  newNode.display_properties.childrenDetached = node.childrenDetached;
  newNode.display_properties.layoutName = node.layoutName;
  newNode.display_properties.cx = node.childrenPosition.x;
  newNode.display_properties.cy = node.childrenPosition.y;
  newNode.display_properties.uw = node.childrenPosition.userWidth;
  newNode.display_properties.uh = node.childrenPosition.userHeight;
  newNode.display_properties.backgroundColor = node.backgroundColor;
  newNode.display_properties.displayStyle = node.displayStyle;
  newNode.title_meta = node.titleMeta;
  newNode.summary_meta = node.summaryMeta;
  newNode.librarySlug = node.librarySlug;
  return newNode;
};

const translateLink = link => {
  const newLink = Object.assign({}, link);
  delete newLink._store;
  newLink.uuid = link.id;
  newLink.fromNodeId = link.fromNodeId;
  newLink.toNodeId = link.toNodeId;
  newLink.linkNodeId = link.linkNodeId;
  newLink.display_properties = {};
  newLink.display_properties.angleStartToR = link.angleStartToR;
  newLink.display_properties.angleEndToR = link.angleEndToR;
  newLink.display_properties.direction = link.direction;
  newLink.display_properties.color = link.color;
  newLink.display_properties.lineType = link.lineType;
  newLink.display_properties.lineWidth = link.lineWidth;
  newLink.display_properties.lineCurvature = link.lineCurvature;
  return newLink;
};

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function generateToken(length) {
  let token = '';
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charsLength = chars.length;

  for (let i = 0; i < length; ++i) {
    token += chars[getRandomInt(0, charsLength - 1)];
  }

  return token;
};

const isUrlPlecticaMap = ({ config, url }) => {
  const { site_url, uri, default_uri } = config;
  const { hostname, pathname, query } = new Url(url, true);
  const parameters = pathname.split(/[\/\?]/);

  if (parameters[1] !== 'maps') return false;
  if (!parameters[2] || parameters[2].length !== 9) return false;

  const relevantURI = uri || default_uri;

  const devUrls = ['dev1.plectica.com', 'dev2.plectica.com', 'dev3.plectica.com', 'dev.plectica.com'];
  const prodUrls = ['beta.plectica.com', 'plectica.com', 'www.plectica.com'];

  if (devUrls.includes(relevantURI.hostname)) {
    return devUrls.includes(hostname);
  } else if (prodUrls.includes(relevantURI.hostname)) {
    return prodUrls.includes(hostname);
  }

  return hostname === relevantURI.hostname;
};

const isUrlInternal = ({ config, access, url }) => {
  const { publicIdentifier } = access;
  const { pathname } = new Url(url);

  const parameters = pathname.split(/[\/\?]/);
  const mapId = parameters[parameters.indexOf('maps') + 1];

  return isUrlPlecticaMap({ config, url }) && mapId === publicIdentifier;
};

const isNotLinkToNodeOrRegion = ({ href }) => {
  const { query } = new Url(href, true);
  return !Object.keys(query).some(param => param === 'nodeid' || param === 'regionId');
};

const getLinksFromString = ({ string }) =>
  linkify
    .find(string)
    .filter(({ type }) => type === 'url')
    // Filter out urls linking to a specific region/node
    .filter(isNotLinkToNodeOrRegion)
    .map(({ href }) => href);

const getPlecticaLinksFromString = ({ string, config }) =>
  getPlecticaLinksFromUrls({
    urls: getLinksFromString({ string }),
    config,
  });

const getPlecticaLinksFromUrls = ({ urls, config }) =>
  urls
  .filter(url => isUrlPlecticaMap({ config, url }))
  .map(url => {
    const { hostname, protocol, pathname, query } = new Url(url);
    // cut off any random crap
    return `${protocol}//${hostname}${pathname.slice(0, 30)}${query}`;
  });

const escapeRegExp = (str) => {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
};

const shuffleArray = (a) => {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

module.exports = {
  translateLink,
  translateNode,
  getRandomInt,
  generateToken,
  isNotLinkToNodeOrRegion,
  isUrlPlecticaMap,
  isUrlInternal,
  getLinksFromString,
  getPlecticaLinksFromString,
  sha1,
  escapeRegExp,
  shuffleArray,
  getPlecticaLinksFromUrls,
};



// WEBPACK FOOTER //
// ./starling/src/lib/shared-util.js